// Material Letter Avatar Color Mapping (26 Distinct A-Z Colors inspired by Google / YouTube)

export const LETTER_COLOR_MAP = {
  A: '#00897b', // Teal (Distinct from Purple)
  B: '#1a73e8', // Google Blue
  C: '#1e8e3e', // Emerald Green
  D: '#e37400', // Deep Orange
  E: '#9334e6', // Violet
  F: '#f43f5e', // Rose Red
  G: '#059669', // Mint Green
  H: '#0284c7', // Sky Blue
  I: '#4f46e5', // Indigo
  J: '#d97706', // Amber Gold
  K: '#7c3aed', // Purple Violet
  L: '#db2777', // Magenta Pink
  M: '#0d9488', // Dark Cyan
  N: '#ea580c', // Bright Tangerine
  O: '#2563eb', // Royal Blue
  P: '#8a3ffc', // Pratham Purple
  Q: '#16a34a', // Forest Leaf
  R: '#dc2626', // Crimson
  S: '#0f62fe', // Speedo Blue
  T: '#0891b2', // Ocean Cyan
  U: '#9333ea', // Deep Orchid
  V: '#ca8a04', // Rich Bronze
  W: '#e11d48', // Ruby Coral
  X: '#4338ca', // Deep Navy
  Y: '#c026d3', // Fuchsia
  Z: '#047857', // Pine Green
};

export const AVATAR_COLOR_PALETTE = Object.values(LETTER_COLOR_MAP);

export function getAvatarColor(identifier) {
  if (!identifier) return LETTER_COLOR_MAP.A;
  const str = String(identifier).trim().replace(/^@/, '');
  if (!str) return LETTER_COLOR_MAP.A;

  // 1. Check for the first alphabetical letter
  const match = str.match(/[a-zA-Z]/);
  if (match) {
    const letter = match[0].toUpperCase();
    if (LETTER_COLOR_MAP[letter]) {
      return LETTER_COLOR_MAP[letter];
    }
  }

  // 2. Deterministic hash fallback for numeric or symbol strings
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % AVATAR_COLOR_PALETTE.length;
  return AVATAR_COLOR_PALETTE[index];
}
